// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3JPkT {\n  width: 100%;\n}\n\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n\nli {\n  font-size: 12px;\n  line-height: 18px;\n  color: #c1c2c2;\n  padding: 4px 8px;\n  margin-right: 19.2px;\n  margin-right: 1.2rem;\n  border: 1px solid #c1c2c2;\n  border-radius: 3px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  cursor: pointer;\n}\n\n._22NHl {\n  border: 1px solid #1f93ff;\n  color: #fff;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "_3JPkT",
	"isActive": "_22NHl"
};
module.exports = exports;
